import React from "react";
import Banner1 from '../assets/images/webBaner.png'
import Banner2 from '../assets/images/webBaner.png'
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import 'swiper/css/pagination';

const SliderNew = () => {
  return (
    <div className="newSwiperWeb">
      <Swiper
      //  autoplay={{
      //   delay: 2500,
      //   disableOnInteraction: false,
      // }}
      autoplay={false}
        modules={[Autoplay,Pagination]} // Enable required modules
        grabCursor={true} // Enable cursor grabbing effect
        slidesPerView="auto" // Show as many slides as necessary to fill the screen
        loop={true} // Enable looping of slides
        pagination={{ clickable: true }}
        className="mySwiper newSwiper" >
        <SwiperSlide>
          <img src={Banner1} alt="" className='img-fluid' />
        </SwiperSlide>
        <SwiperSlide>
          <img src={Banner2} alt="" className='img-fluid' />
        </SwiperSlide>
        <SwiperSlide>
          <img src={Banner1} alt="" className='img-fluid' />
        </SwiperSlide>
        <SwiperSlide>
          <img src={Banner2} alt="" className='img-fluid' />
        </SwiperSlide>
      </Swiper>
    </div>
  );
};

export default SliderNew;
